enum DealEnum {
  BOTH = 'Both',
  ONLINE_OPEN = 'Online Open',
  OPEN_ACCESS = 'Open Access',
}

export default DealEnum;
